import React, { useState, useEffect } from 'react';
import './index.module.less';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import BrowserHistory from '@helpers/BrowserHistory';
import { paths } from '@helpers/Constants';

import ConfirmModal from '@components/ConfirmModal';
import MyDeviceCard from '../MyDeviceCard';
import { IDeviceBindInfo } from '@apis/device/getMyDevices';
import SettingItemCard from '../SettingItemCard';
import { SettingItemInfo } from '../SettingItem/index.d';
import { DeviceStatus } from '@apis/types';
import OfflineHelp  from '@components/OfflineHelp';
import { DeviceDetailInfo } from '@apis/device/getDeviceDetailInfo';
import PageNavigator from '@helpers/PageNavigator';

import iconStatusTipBar from './images/device_page_status_tip_bar_icon.png';
import FridayService from '@services/friday';
interface IMyDevicePageProps {
  info: IDeviceBindInfo;
  visiable: boolean;
}

const MyDevicePage = (props: IMyDevicePageProps) => {
  const { info, visiable } = props;
  const [statusInfo, setDeviceStatusInfo] = useState(null);
  const [deviceDetailInfo, setDeviceDetailInfo] = useState<DeviceDetailInfo>(null);

  useEffect(() => {
    if (visiable) {
      const getMyDeviceStatusInfo = async () => {
        const result = await Http.post(Api.GetCardInfoBySncode,  {
          snCode: info.snCode,
          company: 'lingge'
        });
        setDeviceStatusInfo(result?.data);
      };
      getMyDeviceStatusInfo();
    }
  }, [info.snCode, visiable]);

  useEffect(() => {
    const getDeviceDetailInfo = async () => {
      const result = await Http.post(Api.GetDeviceDetailInfo,  {
        snCode: info.snCode,
        company: 'lingge'
      });
      setDeviceDetailInfo(result?.data);
    };
    getDeviceDetailInfo();
  }, [info.snCode]);

  const online = statusInfo?.status === DeviceStatus.online;
  const childrenCount = deviceDetailInfo?.users?.length || -1;
  const childrenCountText = childrenCount === -1 ? '' : `${childrenCount}`;
  const phoneSettingGroup: SettingItemInfo[] = [
    {
      title: '绑定成员',
      actionText: childrenCountText,
      itemClick: () => {
        FridayService.addEvent('device_information_bind_member_click');
        BrowserHistory.push(`${PUBLIC_URL}${paths.deviceBindMember}?sncode=${info.snCode}`);
      },
      disable: !online
    },
    {
      title: '亲情号设置',
      itemClick: () => {
        BrowserHistory.push(`${PUBLIC_URL}${paths.parentPhoneSetting}?sncode=${info.snCode}&company=${info.company}&version=${info.hardwareVersion}`);
      },
      disable: !online,
    },
    {
      title: 'SOS 求助设置',
      itemClick: () => {
        BrowserHistory.push(`${PUBLIC_URL}${paths.sosPhoneSetting}?sncode=${info.snCode}&company=${info.company}&version=${info.hardwareVersion}`);
      },
      disable: !online,
    },
    {
      title: '通话联系人',
      itemClick: () => {
        BrowserHistory.push(`${PUBLIC_URL}${paths.contactPhoneSetting}?sncode=${info.snCode}&company=${info.company}&version=${info.hardwareVersion}`);
      },
      hideBorder: true,
      disable: !online,
    },
  ];

  const deviceSettingGroup: SettingItemInfo[] = [
    {
      title: '安全守护',
      itemClick: () => {
        FridayService.addEvent('security_guard_self_show', {source: '我的设备'});
        BrowserHistory.push(`${PUBLIC_URL}/guardsettingentry?sncode=${info.snCode}&company=${info.company}`);
      },
      disable: !online,
    },
    {
      title: '上课免打扰',
      itemClick: () => {
        if (!info.bindSchoolUid || info.bindSchoolUid === '001') {
          BrowserHistory.push(`${PUBLIC_URL}/deviceClassDisableSelf?sncode=${info.snCode}&company=${info.company}`)
        } else {
          BrowserHistory.push(`${PUBLIC_URL}/deviceClassDisableEntry?sncode=${info.snCode}&company=${info.company}`)
        }
      },
      disable: !online,
    },
    {
      title: '开关机管理',
      itemClick: () => {
        BrowserHistory.push(`${PUBLIC_URL}${paths.devicePowerPlan}?sncode=${info.snCode}`);
      },
      disable: !online,
    },
    {
      title: '代收短信',
      itemClick: () => {
        BrowserHistory.push(`${PUBLIC_URL}${paths.deviceMessages}?sncode=${info.snCode}`);
      },
      hideBorder: true,
      disable: !online,
    },
  ];

  const otherSettingGroup: SettingItemInfo[] = [
    {
      title: '使用说明',
      itemClick: () => {
        PageNavigator.to({ url: 'https://help.seewo.com/square' });
      },
      hideBorder: true,
    }
  ];


  const status = statusInfo?.status;
  const showBar = !(status == null || status === DeviceStatus.online);
  let desc = '设备状态异常';
  if (status === DeviceStatus.locked) {
    desc = '设备已锁定，请检查锁定原因';
  } else if (status === DeviceStatus.offline) {
    desc = '设备离线，请检查离线原因';
  } else if (status === DeviceStatus.forbid) {
    desc = '设备已禁用，请检查禁用原因';
  }
  const statusTipBar = showBar ? (
    <div styleName="status-tip-bar" onClick={() => {
      if (status === DeviceStatus.locked) {
        ConfirmModal.show({
          title: '设备已锁定',
          text: '设备插入的SIM卡不是服务商提供，因此设备已被锁定，解锁请插入服务商提供的SIM卡，并确认SIM卡可正常使用。',
          confirmBtnText: '我知道了',
        });
      } else if (status === DeviceStatus.offline) {
        OfflineHelp.show();
      } else if (status === DeviceStatus.forbid) {
        ConfirmModal.show({
          title: '设备已禁用',
          text: '设备已被服务商禁用，请联系服务商解除。',
          confirmBtnText: '我知道了',
          confirmBtnStyle: { backgroundColor: '#F2F4F7', color: '#55585C'},
        });
      }
    }}>
      <div styleName="tip-wrapper">
        <img
          styleName="icon"
          src={iconStatusTipBar}
          alt=""
        />
        <div styleName="text">{desc}</div>
      </div>
      <i className="iconfont icon-icon-action-arrow" styleName="arrow" />
    </div>
  ) : null;


  return (
    <div styleName="container">
      {statusTipBar}
      <div styleName="settings">
        <div style={{ height: '.24rem' }} />
        <MyDeviceCard info={info} statusInfo={statusInfo} />
        <div style={{ height: '.24rem' }} />
        <SettingItemCard infoList={phoneSettingGroup} />
        <div style={{ height: '.24rem' }} />
        <SettingItemCard infoList={deviceSettingGroup} />
        <div style={{ height: '.24rem' }} />
        <SettingItemCard infoList={otherSettingGroup} />
      </div>
    </div>
  );
};

export default MyDevicePage;
